import React from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import ProfileBanner from '../ProfileBanner';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';

const Banner = ({ user, updateUser, updateUserSuspend }) => {
  const primaryLicenseType = [
    {
      name: 'Registered Nurse (RN)',
      value: 'RN'
    },
    {
      name: 'Licensed Practical Nurse (LPN)',
      value: 'LPN'
    },
    {
      name: 'Certified Nurse Assistance (CNA)',
      value: 'CNA'
    },
    {
      name: 'Home Health Aide (HHA)',
      value: 'HHA'
    }
  ];

  const format = value => {
    const inputPhoneNumber = value?.replace(/\D/g, '');
    const limitedPhoneNumber = inputPhoneNumber?.slice(0, 10);
    const formattedPhoneNumber =
      limitedPhoneNumber?.length === 10
        ? limitedPhoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        : limitedPhoneNumber;
    return formattedPhoneNumber;
  };

  return (
    <ProfileBanner>
      <ProfileBanner.Header
        avatar={
          user?.profileImage
            ? user?.profileImage
            : user?.firstName + ' ' + user?.lastName
        }
        user={user}
        coverSrc={''}
      />
      <ProfileBanner.Body>
        <Row>
          <Col lg={6}>
            <h4 className="mb-1">
              {user?.firstName} {user?.lastName}{' '}
              <span className="text-primary">
                (
                {user?.poolType === 'Internal Pool'
                  ? 'Internal Staff'
                  : user?.poolType === 'Float Pool'
                  ? 'Float'
                  : user?.poolType}
                )
              </span>
              {/* <VerifiedBadge /> */}
            </h4>
            <h5 className="fs-9 fw-normal">
              {
                primaryLicenseType.filter(
                  i => i?.value === user?.primaryLicenseType
                )[0]?.name
              }
            </h5>
            <p className="text-500">{user?.fullAddress}</p>
            <Button
              as={Link}
              to={paths.nursd_profile_edit(user?.id)}
              variant="falcon-default"
              size="sm"
              className="px-3"
            >
              Edit Profile
            </Button>
            {/* <Button variant="falcon-default" size="sm" className="px-3">
              Message
            </Button> */}
            <Button
              size="sm"
              variant={user?.nurseLoginControl ? 'danger' : 'success'}
              className="mx-2"
              onClick={() =>
                user?.nurseLoginControl
                  ? updateUser(
                      user?.id,
                      {
                        nurseLoginControl: false
                      },
                      user?.firstName + ' ' + user?.lastName,
                      'Deactivate'
                    )
                  : updateUser(
                      user?.id,
                      {
                        nurseLoginControl: true
                      },
                      user?.firstName + ' ' + user?.lastName,
                      'Activate'
                    )
              }
            >
              {user?.nurseLoginControl ? 'Deactivate' : 'Activate'}
            </Button>
            {user?.nurseLoginControl && (
              <Button
                size="sm"
                variant={user?.nurseAppAccessControl ? 'success' : 'danger'}
                onClick={() =>
                  user?.nurseAppAccessControl
                    ? updateUserSuspend(
                        user?.id,
                        {
                          nurseAppAccessControl: false
                        },
                        user?.firstName + ' ' + user?.lastName,
                        'Unsuspend'
                      )
                    : updateUserSuspend(
                        user?.id,
                        {
                          nurseAppAccessControl: true
                        },
                        user?.firstName + ' ' + user?.lastName,
                        'Suspend'
                      )
                }
              >
                {user?.nurseAppAccessControl ? 'Unsuspend' : 'Suspend'}
              </Button>
            )}
            <div className="border-dashed border-bottom my-4 d-lg-none" />
          </Col>
          <Col className="ps-2 ps-lg-3">
            <Table
              borderless
              className="fw-medium font-sans-serif fs-10 h-100 mb-0"
            >
              <tbody>
                <tr className="hover-actions-trigger">
                  <td className="p-1" style={{ width: '35%' }}>
                    Email:
                  </td>
                  <td className="p-1 text-600">
                    <a
                      href={`mailto:${user?.emailId}`}
                      className="text-600 text-decoration-none text-primary"
                    >
                      {user?.emailId}
                    </a>
                  </td>
                </tr>
                <tr className="hover-actions-trigger">
                  <td className="p-1" style={{ width: '35%' }}>
                    Mobile No:
                  </td>
                  <td className="p-1 text-600">
                    <a
                      href={`tel:${user?.phoneNumber}`}
                      className="text-600 text-decoration-none"
                    >
                      {format(user?.phoneNumber)}
                    </a>
                  </td>
                </tr>
                <tr className="hover-actions-trigger">
                  <td className="p-1" style={{ width: '35%' }}>
                    Organization:
                  </td>
                  <td className="p-1 text-600">{user?.organization}</td>
                </tr>
                <tr className="hover-actions-trigger">
                  <td className="p-1" style={{ width: '35%' }}>
                    Office ID:
                  </td>
                  <td className="p-1 text-600">{user?.location_id}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </ProfileBanner.Body>
    </ProfileBanner>
  );
};

Banner.propTypes = {
  user: PropTypes.any,
  updateUser: PropTypes.any,
  updateUserSuspend: PropTypes.any
};

export default Banner;
